const productslider = {
    getlist: 'productslider/getlist',
    add: 'productslider/add',
    update: 'productslider/update',
    remove: 'productslider/remove',
    get: 'productslider/get',
}
export default productslider
